<template>
<div>
    <!-- main Contents -->
    <body>
        <div id="skipToContent">
            <a href="#contents">콘텐츠 바로가기 </a>
        </div>
        <!-- main -->
        <main>
            <!-- header -->
            <div class="header">
                <div class="header_inner">
                    <div class="header_logo">
                        <h1>
                            <a :href="logoClicklink" target="_self" >Amway</a>
                        </h1>
                    </div>
                </div>
            </div>

            <!-- contents-->
            <div class="contents">
                <!-- visual -->
                <div class="concierce_visual">
                    <h2 class="visual_title">"I'M PROUD OF YOU"</h2>
                    <p class="visual_desc">Rich와 Jay의 다이아몬드 리더님을 향한 마음을 되새기겠습니다.</p>
                    <span class="visual_label">
                        <img src="./images/concierce_label.png" alt="DIAMOND CONCIERGE">
                    </span>
                </div>

                <voucher 
                    :coupons="this.coupons"
                    :aboInfo="this.aboInfo"
                    @couponIdx="getCouponTotalCount" />

                <!-- information -->
                <infotag />

                <!-- use list -->
                <uselist 
                    :couponsDetails="this.couponsDetails"
                    :isexpired="this.couponExpired"
                    @setcouponRetrieve="setcouponRetrieve"
                    @updateListSize="updateDetailsSize"
                    @updateListMode="updateDetailsMode"
                    @scrollLockWhenPopupOpen="scrollLockWhenPopupOpen"  />
            </div>
        </main>
        <!-- //main -->

	</body>
</div>
</template>


   
<script>
// Component
import voucher from './component/voucher.vue'
import uselist from './component/uselist.vue'
import infotag from './component/infotag.vue'

// Library
import axios from 'axios'
import querystring from 'querystring'

export default {
    metaInfo: {
    title: '다이아몬드 컨시어지 파이토 카페 바우처 선물하기',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'NY Fee Bundle'},
        { name:'robots', content:'index,follow'},
        { property:'og:description', content:'한웨이님이 선물하신 ABC 파이토 카페 음료 바우처를 사용해 보세요.'},
        { property:'og:image', content:'./images/concierce_kakao_thumb.png'}
    ]
    },
    name: 'conciergeMain',
    components: {
        voucher,
		uselist,
		infotag
    },
    data () {
        return {
            aboInfo: Object,
            token_body: {
                client_id: process.env.OCC_AUTH_CLIENT_ID,
                client_secret: process.env.OCC_AUTH_CLIENT_SECRET,
                grant_type: process.env.OCC_AUTH_GRANT_TYPE
            },
            logoClicklink: process.env.AMWAY_ROOT_URL,
            au_token: Object,
            coupons: [],
            choiceCoupon: Object,
            couponExpired: false,
            couponsDetails: [],
            listSpec: Object,
            listTotalSize: Number,
            ready: false,
        }
    },
    methods: {
        init: async function () { // 초기화
            this.aboInfo = {aboNo: '', aboName: '', aboPhone: '', pinLevel: ''},
            this.coupons = [],
            this.couponsDetails = [],
            this.listSpec = {couponId:0, pageNum:1, listSize:10, listMode:'A', isAdd:false},
            this.listTotalSize = 0,
            this.au_token = '',

            await this.checkLogin() // 로그인 체크(회원번호,이름)
            if (this.aboInfo.aboNo) await this.getABOCouponList() // 바우처정보 가져오기
        },

        scrollLockWhenPopupOpen: function(flag){
            if(flag){
                document.documentElement.style.overflow = 'hidden'
            }else{
                document.documentElement.style.overflow = 'auto'
            }
        },
        /**
         * 로그인 체크
         * Hybris OCC  
         **/ 
        checkLogin: async function () {
        await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
        ).then(response => {
            if (response.data.header.status === 'ERROR') { // login fail
                window.location.href = process.env.AMWAY_ROOT_URL + '/login'
            } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
                // login success
                this.aboInfo.aboNo = atob(response.data.customerUid)
                this.aboInfo.aboName = response.data.name
            }
        }).catch(ex => {
            alert('로그인이 필요합니다.')
            window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        })
        },

        /**
         * 이벤트 바우처 리스트 조회
         * Lambda 호출
         **/ 
        getABOCouponList: async function(){
            await axios.post(
                process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-login-info', 
            {
                abo_no: this.aboInfo.aboNo
            }).then(response => {
                if (response.status === 200) {
                    if (response.data.results === null) {
                        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
                    } else {
                        this.coupons = JSON.parse(response.data.results)
                        if (this.coupons.length > 0) {
                            this.listSpec.couponId=this.coupons[0].id
                            this.getCouponTotalCount(this.coupons[0])
                        }
                    }
                } else {
                    console.log('response.status : ', response.status)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
                }
                }).catch(error => {
                    console.log('error : ', error)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            })
        },

        /**
         * 이벤트 바우처 사용 리스트 조회
         * Lambda 호출
         **/  
        getCouponDetailListCall: async function (){
            await axios.post(
                process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-used-list', 
            {
                "user_id": this.listSpec.couponId,
                "page_no": this.listSpec.pageNum,
                "page_size": this.listSpec.listSize,
                "in_mode": this.listSpec.listMode
            }).then(response => {
                if (response.status === 200) {
                    if (response.data.results === null) {
                        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
                    } else {
                        var json = JSON.parse(response.data.totalCount)
                        this.listTotalSize = (json[0].CNT !== null ? json[0].CNT : 0)
                        if(this.listSpec.isAdd){
                            this.couponsDetails = Array.concat(this.couponsDetails, JSON.parse(response.data.results))
                        }else{
                            this.couponsDetails = JSON.parse(response.data.results)
                        }
                    }
                } else {
                    console.log('response.status : ', response.status)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
                }
                }).catch(error => {
                    console.log('error : ', error)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            })
        },

        /**
         * 이벤트 바우처 선물 회수 
         * Lambda 호출
         **/ 
        couponRetrieveCall: async function(couponDetailObj){
            await axios.post(
                process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-send-gift-cancel', 
            {
                "coupon_id": couponDetailObj.coupon_number,
                "user_id": couponDetailObj.user_id,
                "modifiedBy": this.aboInfo.aboNo,
                "send_no": couponDetailObj.mobile_number,
                "abo_nm": this.aboInfo.aboName,
            }).then(response => {
                if (response.status === 200) {
                    alert('바우처 선물을 취소하였습니다.');
                    // 팝업 닫기
                    this.scrollLockWhenPopupOpen(false);
                    // 바우처 리스트 초기화 
                    this.getABOCouponList();
                    // 바우처 상세 초기화
                } else {
                    console.log('response.status : ', response.status)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
                }
                }).catch(error => {
                    console.log('error : ', error)
                    alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            })
        },

        getCouponTotalCount: function(couponIdx){
            this.choiceCoupon=couponIdx;
            this.couponExpired=(this.choiceCoupon.isexpired?true:false);
            if(this.choiceCoupon.id >= 0){
                this.listSpec.couponId=this.choiceCoupon.id; // 발급 바우처 변경
                this.listSpec.pageNum=1
                this.listSpec.isAdd=false
                // 리스트 다시 가져오기
                this.getCouponDetailListCall();
            }
        },

        setcouponRetrieve: function(couponDetailObj){
            this.couponRetrieveCall(couponDetailObj);
        },
        
        updateDetailsSize: function(){
            if( (this.listSpec.pageNum * this.listSpec.listSize) >= this.listTotalSize){
                alert('더 이상 조회 목록이 없습니다.')
            }else{
                this.listSpec.pageNum++
                this.listSpec.isAdd=true
                if(this.couponsDetails.length > 0 ){
                    this.getCouponDetailListCall();
                }
            }
        },
        updateDetailsMode: function(mode){
            this.listSpec.listMode=mode;
            this.listSpec.pageNum=1
            this.listSpec.isAdd=false
            this.getCouponDetailListCall();
        },
    },
    mounted() {
        window.setTimeout(() => {
            this.ready = true
            this.init()
            }, 500)
    },    
}
</script>

<style>
    @import './css/concierce.css';
</style>



// WEBPACK FOOTER //
// src/views/concierge/conciergeMain.vue